// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationChains_container__heSqq","logos":"ApplicationChains_logos__BiNDG","logo":"ApplicationChains_logo__h2_q6","label":"ApplicationChains_label__oLRNy"};